import { SortableContext, rectSwappingStrategy } from '@dnd-kit/sortable';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { useHistory } from 'react-router';

import AnnotatorConstants from '../annotator.constants';
import { disableDragAtom } from '../findingSidebar/confidenceScoreFilter/atoms';
import type { ImageObject } from '../types';

import FindingViewer from './findingViewer/FindingViewer';
import { ImageLayoutContainer } from './imageLayoutContainer/ImageLayoutContainer';
import type { LayoutViewerProps } from './MultiFileViewer.types';

export const LayoutViewer = (layoutProps: LayoutViewerProps) => {
  const isDragDisabled = useAtomValue(disableDragAtom);

  // Determine if we're in Series view (BITEWING filter with Series view available)
  const isInSeriesView =
    layoutProps.shouldUseSeriesView &&
    layoutProps.currentImageFilter === AnnotatorConstants.BITEWING;

  // Disable drag and drop in Series view OR when confidence score filter is active
  const shouldDisableDrag = Boolean(isDragDisabled || isInSeriesView);

  const history = useHistory();

  return (
    <>
      <SortableContext
        items={layoutProps.sortedAndFilteredImages.map(
          (i: { fmxIndex: number }) => i.fmxIndex ?? 999,
        )}
        strategy={rectSwappingStrategy}
        id="fmx-viewer"
      >
        <div
          className={classNames(layoutProps.classes.grid, 'redesign-enabled')}
        >
          {layoutProps.sortedAndFilteredImages.map(
            (currentImage: ImageObject, index: number) => {
              const setSelectedImage = () => {
                if (
                  !currentImage.imageId ||
                  layoutProps.isRotationButtonHovered.includes(
                    currentImage.imageId,
                  )
                ) {
                  return;
                }
                const newRoute = `${history.location.pathname}/${currentImage.imageId}`;
                history.push({
                  pathname: newRoute,
                  search: history.location.search,
                });
                layoutProps.onUpdateOdontogramView(false);
                layoutProps.onExpandSidebar(true);
              };

              return (
                <ImageLayoutContainer
                  // @ts-expect-error TS(2783): 'currentImageFilter' is specified more than once, ... Remove this comment to see the full error message
                  currentImageFilter={layoutProps.currentImageFilter}
                  currentImage={currentImage}
                  currentIndex={index}
                  onSetSelectedImage={setSelectedImage}
                  // @ts-expect-error TS(2783): 'setCurrentlyHoveredImageId' is specified more tha... Remove this comment to see the full error message
                  onSetCurrentlyHoveredImageId={
                    layoutProps.onSetCurrentlyHoveredImageId
                  }
                  // @ts-expect-error TS(2783): 'noImagesOnCurrentView' is specified more than onc... Remove this comment to see the full error message
                  noImagesOnCurrentView={layoutProps.noImagesOnCurrentView}
                  disableDrag={shouldDisableDrag}
                  key={`${currentImage.imageId}-${currentImage.fmxIndex}`}
                  {...layoutProps}
                >
                  <FindingViewer
                    activeImage={currentImage}
                    patient={layoutProps.currentPatient}
                    // @ts-expect-error TS(2783): 'isThumbnail' is specified more than once, so this... Remove this comment to see the full error message
                    isThumbnail
                    {...layoutProps}
                    index={index}
                  />
                </ImageLayoutContainer>
              );
            },
          )}
        </div>
      </SortableContext>
    </>
  );
};
